import axios from "axios";
import articlesCalc, { TimeHelper } from "./articlesCalcService";

export class CostEstimateRowsCalculator {
    static getQuantity = row => {
        if (row.objectsPerRow != undefined && row.objectsPerRow > 0) {
            return Math.ceil(multiplier / row.objectsPerRow);
        }
        return multiplier;
    };

    static getTotalProductionCost = props => {
        let totalCost = 0.0;

        props.rows.forEach(row => {
            let multiplier = Number.parseFloat(props.multiplier);

            if (row.objectsPerRow != undefined && row.objectsPerRow > 0) {
                multiplier = Math.ceil(multiplier / row.objectsPerRow);
            }

            if (row.is_single) multiplier = 1;

            const calc = new articlesCalc();
            calc.setData(row);
            let cost = Number.parseFloat(calc.getProductionCost(multiplier));

            row.children.forEach(childRow => {
                multiplier = Number.parseFloat(props.multiplier);
                if (childRow.objectsPerRow != undefined) {
                    multiplier = Math.ceil(multiplier / childRow.objectsPerRow);
                }

                if (row.is_single) multiplier = 1;

                calc.setData(childRow);

                if (row.objectsPerRow != undefined && row.objectsPerRow > 0 && childRow.auto_calculate_function_name == 'materialAreaM2') {
                    multiplier = Math.ceil(multiplier / row.objectsPerRow);
                }

                cost += Number.parseFloat(calc.getProductionCost(multiplier));
            });
            if (Number.isNaN(cost)) {
                cost = 0.0;
            }

            totalCost += Number.parseFloat(cost);
        });

        return totalCost.toFixed(2);
    };

    static getTotalExtraCost = props => {
        let totalCost = 0.0;
        props.rows.forEach(row => {
            const calc = new articlesCalc();
            calc.setData(row);

            let multiplier = Number.parseFloat(props.multiplier);
            if (row.is_single) multiplier = 1;

            let cost = Number.parseFloat(calc.get("extra_cost")) * multiplier;

            row.children.forEach(childRow => {
                calc.setData(childRow);

                let multiplier = Number.parseFloat(props.multiplier);
                if (childRow.is_single) multiplier = 1;

                cost +=
                    Number.parseFloat(calc.get("extra_cost")) *
                    Number.parseFloat(multiplier);
            });
            if (Number.isNaN(cost)) {
                cost = 0.0;
            }
            totalCost += Number.parseFloat(cost);
        });

        return totalCost.toFixed(2);
    };

    static getTotalStartTime = props => {
        let totalSeconds = 0;
        props.rows.forEach(row => {
            const calc = new articlesCalc();
            calc.setData(row);
            let seconds = Number.parseFloat(calc.getStartSeconds());

            row.children.forEach(childRow => {
                calc.setData(childRow);
                seconds += Number.parseFloat(calc.getStartSeconds());
            });

            if (Number.isNaN(seconds)) {
                seconds = 0;
            }
            totalSeconds += Number.parseInt(seconds);
        });

        return TimeHelper.formatSecondsAsTime(totalSeconds);
    };

    static getTotalProductionTime = props => {
        let totalSeconds = 0;
        props.rows.forEach(row => {
            const calc = new articlesCalc();
            calc.setData(row);

            let seconds = Number.parseFloat(calc.getProductionSeconds());

            var multiplier = Number.parseFloat(props.multiplier);
            if (row.is_single) multiplier = 1;

            if (row.objectsPerRow != undefined && row.objectsPerRow > 0) {
                multiplier = Math.ceil(multiplier / row.objectsPerRow);
            }

            seconds *= multiplier;

            row.children.forEach(childRow => {
                calc.setData(childRow);

                var multiplier = Number.parseFloat(props.multiplier);
                if (childRow.is_single) multiplier = 1;

                if (row.objectsPerRow != undefined && row.objectsPerRow > 0 && childRow.auto_calculate_function_name == 'materialAreaM2') {
                    multiplier = Math.ceil(multiplier / row.objectsPerRow);
                }

                seconds +=
                    Number.parseFloat(calc.getProductionSeconds()) * multiplier;
            });

            if (Number.isNaN(seconds)) {
                seconds = 0;
            }

            totalSeconds += Number.parseFloat(seconds);
        });

        return TimeHelper.formatSecondsAsTime(totalSeconds);
    };

    static getTotalTime = props => {
        const startTimeSeconds = TimeHelper.timeStringToSec(
            CostEstimateRowsCalculator.getTotalStartTime(props)
        );

        const prodTimeSeconds = TimeHelper.timeStringToSec(
            CostEstimateRowsCalculator.getTotalProductionTime(props)
        );

        return TimeHelper.formatSecondsAsTime(
            startTimeSeconds + prodTimeSeconds
        );
    };

    static getTotalPurchasePrice = props => {
        let totalPurchasePrice = 0.0;

        props.rows.forEach(row => {
            let multiplier = Number.parseFloat(props.multiplier);

            if (row.objectsPerRow != undefined && row.objectsPerRow > 0) {
                if (row.infoboard_id == 1 || row.infoboard_id == 3 || (row.infoboard_id == 5 && row.mode == 'waste')) {
                    multiplier = Math.ceil(multiplier / row.objectsPerRow);
                } else if (row.infoboard_id == 2 || (row.infoboard_id == 5 && row.mode == 'size')) {

                    if (row.infoboard_id == 5) {
                        multiplier = Math.ceil(multiplier / row.objectsPerRow);
                    } else {
                        multiplier = Math.ceil(multiplier / row.objectsPerRow) * row.objectsPerRow;
                    }
                }
            }

            if (row.is_single) multiplier = 1;

            const calc = new articlesCalc();
            calc.setData(row);
            let price = Number.parseFloat(calc.getPurchasePrice()) * multiplier;

            row.children.forEach(childRow => {
                multiplier = Number.parseFloat(props.multiplier);

                if (row.is_single) multiplier = 1;

                calc.setData(childRow);

                if (row.objectsPerRow != undefined && row.objectsPerRow > 0 && childRow.auto_calculate_function_name == 'materialAreaM2') {
                    multiplier = Math.ceil(multiplier / row.objectsPerRow);
                }

                price += Number.parseFloat(calc.getPurchasePrice()) * multiplier;
            });
            if (Number.isNaN(price)) {
                price = 0.0;
            }

            totalPurchasePrice += Number.parseFloat(price);
        });

        return totalPurchasePrice.toFixed(2);
    };

    static getTotalWeight = props => {
        let totalWeight = 0.0;
        props.rows.forEach(row => {
            const calc = new articlesCalc();
            calc.setData(row);
            let weight = Number.parseFloat(calc.get("weight"));
            var multiplier = Number.parseFloat(props.multiplier);

            if (row.objectsPerRow != undefined && row.objectsPerRow > 0 && row.infoboard_id != 2) {
                multiplier = Math.ceil(multiplier / row.objectsPerRow);
            }

            if (row.is_single) multiplier = 1;

            weight *= multiplier;

            row.children.forEach(childRow => {
                calc.setData(childRow);
                let _weight = Number.parseFloat(calc.get("weight"));

                if (Number.isNaN(_weight)) {
                    _weight = 0.0;
                }

                if (childRow.is_single) {
                    weight +=
                        Number.parseFloat(_weight);
                } else {
                    weight +=
                        Number.parseFloat(_weight) *
                        Number.parseFloat(props.multiplier);
                }
            });

            if (Number.isNaN(weight)) {
                weight = 0.0;
            }
            
            totalWeight += Number.parseFloat(weight);
        });

        return totalWeight.toFixed(2);
    };

    static getTotalMarginSek = props => {
        let totalPurchasePrice = 0;
        let totalProductionCost = 0;
        let totalPriceAfterDiscount = 0;

        props.rows.forEach(row => {
            const calc = new articlesCalc();
            calc.setData(row);

            var multiplier = Number.parseFloat(props.multiplier);

            if (row.objectsPerRow != undefined && row.objectsPerRow > 0) {
                if (row.infoboard_id == 1 || row.infoboard_id == 3 || (row.infoboard_id == 5 && row.mode == 'waste')) {
                    multiplier = Math.ceil(multiplier / row.objectsPerRow);
                } else if (row.infoboard_id == 2 || (row.infoboard_id == 5 && row.mode == 'size')) {
                    multiplier =
                        Math.ceil(multiplier / row.objectsPerRow) *
                        row.objectsPerRow;
                }
            }

            if (row.is_single) multiplier = 1;

            totalPurchasePrice += Number.parseFloat(
                calc.getPurchasePrice(multiplier)
            );

            totalProductionCost += Number.parseFloat(
                calc.getProductionCost(multiplier)
            );

            totalPriceAfterDiscount += Number.parseFloat(
                calc.getPriceAfterDiscount(multiplier)
            );

            row.children.forEach(childRow => {
                calc.setData(childRow);

                multiplier = childRow.is_single
                    ? 1
                    : Number.parseFloat(props.multiplier);

                if (row.objectsPerRow != undefined && row.objectsPerRow > 0 && childRow.auto_calculate_function_name == 'materialAreaM2') {
                    multiplier = Math.ceil(multiplier / row.objectsPerRow);
                }

                totalPurchasePrice += Number.parseFloat(
                    calc.getPurchasePrice(multiplier)
                );

                totalProductionCost += Number.parseFloat(
                    calc.getProductionCost(multiplier)
                );

                totalPriceAfterDiscount += Number.parseFloat(
                    calc.getPriceAfterDiscount(multiplier)
                );
            });
        });

        if (
            isNaN(totalPurchasePrice) ||
            isNaN(totalProductionCost) ||
            isNaN(totalPriceAfterDiscount)
        )
            return "0.00";
        return totalPriceAfterDiscount - totalPurchasePrice - totalProductionCost;
    };

    static getTotalMargin = props => {
        let totalPurchasePrice = 0;
        let totalProductionCost = 0;
        let totalPriceAfterDiscount = 0;

        props.rows.forEach(row => {
            const calc = new articlesCalc();
            calc.setData(row);

            var multiplier = Number.parseFloat(props.multiplier);

            if (row.objectsPerRow != undefined && row.objectsPerRow > 0) {
                if (row.infoboard_id == 1 || row.infoboard_id == 3 || (row.infoboard_id == 5 && row.mode == 'waste')) {
                    multiplier = Math.ceil(multiplier / row.objectsPerRow);
                } else if (row.infoboard_id == 2 || (row.infoboard_id == 5 && row.mode == 'size')) {
                    multiplier =
                        Math.ceil(multiplier / row.objectsPerRow) *
                        row.objectsPerRow;
                }
            }

            if (row.is_single) multiplier = 1;

            totalPurchasePrice += Number.parseFloat(
                calc.getPurchasePrice(multiplier)
            );

            totalProductionCost += Number.parseFloat(
                calc.getProductionCost(multiplier)
            );

            totalPriceAfterDiscount += Number.parseFloat(
                calc.getPriceAfterDiscount(multiplier)
            );

            row.children.forEach(childRow => {
                calc.setData(childRow);

                multiplier = childRow.is_single
                    ? 1
                    : Number.parseFloat(props.multiplier);

                if (row.objectsPerRow != undefined && row.objectsPerRow > 0 && childRow.auto_calculate_function_name == 'materialAreaM2') {
                    multiplier = Math.ceil(multiplier / row.objectsPerRow);
                }

                totalPurchasePrice += Number.parseFloat(
                    calc.getPurchasePrice(multiplier)
                );

                totalProductionCost += Number.parseFloat(
                    calc.getProductionCost(multiplier)
                );

                totalPriceAfterDiscount += Number.parseFloat(
                    calc.getPriceAfterDiscount(multiplier)
                );
            });
        });

        if (
            isNaN(totalPurchasePrice) ||
            isNaN(totalProductionCost) ||
            isNaN(totalPriceAfterDiscount)
        )
            return "0.00";
        const totalMarginSek =
            totalPriceAfterDiscount - totalPurchasePrice - totalProductionCost;

        if (totalPriceAfterDiscount == 0) return 0;

        return ((totalMarginSek / totalPriceAfterDiscount) * 100).toFixed(2);
    };

    static getTotalPrice = props => {
        let totalPrice = 0;

        props.rows.forEach(row => {
            const calc = new articlesCalc();
            calc.setData(row);

            var multiplier = Number.parseFloat(props.multiplier);
            if (row.objectsPerRow != undefined && row.objectsPerRow > 0) {
                
                if (row.infoboard_id == 1 || row.infoboard_id == 3 || (row.infoboard_id == 5 && row.mode == 'waste')) {
                    multiplier = Math.ceil(multiplier / row.objectsPerRow);
                } else if (row.infoboard_id == 2 || (row.infoboard_id == 5 && row.mode == 'size')) {
                    multiplier =
                        Math.ceil(multiplier / row.objectsPerRow) *
                        row.objectsPerRow;
                }
            }

            if (row.is_single) multiplier = 1;

            let price = Number.parseFloat(calc.getPrice(multiplier));

            row.children.forEach(childRow => {
                calc.setData(childRow);

                multiplier = childRow.is_single
                    ? 1
                    : Number.parseFloat(props.multiplier);

                if (row.objectsPerRow != undefined && row.objectsPerRow > 0 && childRow.auto_calculate_function_name == 'materialAreaM2') {
                    
                    multiplier = Math.ceil(multiplier / row.objectsPerRow);
                }

                price += Number.parseFloat(calc.getPrice(multiplier));
            });

            if (Number.isNaN(price)) {
                price = 0.0;
            }
            totalPrice += price;
        });

        return totalPrice.toFixed(2);
    };

    static getTotalUnitPrice = props => {
        if (props.multiplier == 0) return "0.00";

        let totalPrice = 0;

        props.rows.forEach(row => {
            const calc = new articlesCalc();
            calc.setData(row);

            var multiplier = Number.parseFloat(props.multiplier);

            if (row.objectsPerRow != undefined && row.objectsPerRow > 0) {
                if (row.infoboard_id == 1 || row.infoboard_id == 3 || (row.infoboard_id == 5 && row.mode == 'waste')) {
                    multiplier = Math.ceil(multiplier / row.objectsPerRow);
                } else if (row.infoboard_id == 2 || (row.infoboard_id == 5 && row.mode == 'size')) {
                    multiplier =
                        Math.ceil(multiplier / row.objectsPerRow) *
                        row.objectsPerRow;
                }
            }

            if (row.is_single) multiplier = 1;

            let price = Number.parseFloat(calc.getPrice(multiplier));

            row.children.forEach(childRow => {
                calc.setData(childRow);

                multiplier = childRow.is_single
                    ? 1
                    : Number.parseFloat(props.multiplier);

                if (row.objectsPerRow != undefined && row.objectsPerRow > 0 && childRow.auto_calculate_function_name == 'materialAreaM2') {
                    multiplier = Math.ceil(multiplier / row.objectsPerRow);
                }

                price += Number.parseFloat(calc.getPrice(multiplier));
            });
            if (Number.isNaN(price)) {
                price = 0.0;
            }
            totalPrice += price;
        });

        return (totalPrice / props.multiplier).toFixed(2);
    };

    static getTotalDiscount = props => {
        let totalPrice = 0;
        let totalPriceAfterDiscount = 0;
        const calc = new articlesCalc();

        props.rows.forEach(row => {
            calc.setData(row);

            let multiplier = Number.parseFloat(props.multiplier);

            if (isNaN(multiplier)) {
                multiplier = 1;
            }

            if (row.objectsPerRow != undefined && row.objectsPerRow > 0) {
                if (row.infoboard_id == 1 || row.infoboard_id == 3 || (row.infoboard_id == 5 && row.mode == 'waste')) {
                    multiplier = Math.ceil(multiplier / row.objectsPerRow);
                } else if (row.infoboard_id == 2 || (row.infoboard_id == 5 && row.mode == 'size')) {
                    multiplier =
                        Math.ceil(multiplier / row.objectsPerRow) *
                        row.objectsPerRow;
                }
            }

            if (row.is_single) multiplier = 1;

            totalPrice += Number.parseFloat(calc.getPrice(multiplier));
            totalPriceAfterDiscount += Number.parseFloat(
                calc.getPriceAfterDiscount(multiplier)
            );

            row.children.forEach(childRow => {
                calc.setData(childRow);
                multiplier = childRow.is_single
                    ? 1
                    : Number.parseFloat(props.multiplier);

                if (row.objectsPerRow != undefined && row.objectsPerRow > 0 && childRow.auto_calculate_function_name == 'materialAreaM2') {
                    multiplier = Math.ceil(multiplier / row.objectsPerRow);
                }

                if (isNaN(multiplier)) {
                    multiplier = 1;
                }

                totalPrice += Number.parseFloat(calc.getPrice(multiplier));
                totalPriceAfterDiscount += Number.parseFloat(
                    calc.getPriceAfterDiscount(multiplier)
                );
            });
        });

        let totalDiscountSek = totalPrice - totalPriceAfterDiscount;

        if (totalDiscountSek == 0) return Number(0).toFixed(2);

        return ((totalDiscountSek / totalPrice) * 100).toFixed(2);
    };

    static hasAnyDiscount = props => {
        const calc = new articlesCalc();

        for (const row of props.rows) {
            calc.setData(row);

            let multiplier = Number.parseFloat(props.multiplier);

            if (isNaN(multiplier)) {
                multiplier = 1;
            }

            if (row.objectsPerRow != undefined && row.objectsPerRow > 0) {
                if (row.infoboard_id == 1 || row.infoboard_id == 3 || (row.infoboard_id == 5 && row.mode == 'waste')) {
                    multiplier = Math.ceil(multiplier / row.objectsPerRow);
                } else if (row.infoboard_id == 2 || (row.infoboard_id == 5 && row.mode == 'size')) {
                    multiplier =
                        Math.ceil(multiplier / row.objectsPerRow) *
                        row.objectsPerRow;
                }
            }

            if (row.is_single) multiplier = 1;

            const rowPrice = Number.parseFloat(calc.getPrice(multiplier));
            const rowPriceAfterDiscount = Number.parseFloat(
                calc.getPriceAfterDiscount(multiplier)
            );

            if (!Number.isNaN(rowPrice) && !Number.isNaN(rowPriceAfterDiscount) && rowPriceAfterDiscount < rowPrice) {
                return true;
            }

            for (const childRow of row.children) {
                calc.setData(childRow);
                multiplier = childRow.is_single
                    ? 1
                    : Number.parseFloat(props.multiplier);

                if (row.objectsPerRow != undefined && row.objectsPerRow > 0 && childRow.auto_calculate_function_name == 'materialAreaM2') {
                    multiplier = Math.ceil(multiplier / row.objectsPerRow);
                }

                if (isNaN(multiplier)) {
                    multiplier = 1;
                }

                const childRowPrice = Number.parseFloat(calc.getPrice(multiplier));
                const childRowPriceAfterDiscount = Number.parseFloat(
                    calc.getPriceAfterDiscount(multiplier)
                );

                if (!Number.isNaN(childRowPrice) && !Number.isNaN(childRowPriceAfterDiscount) && childRowPriceAfterDiscount < childRowPrice) {
                    return true;
                }
            }
        }

        return false;
    };

    static getTotalPriceAfterDiscount = props => {
        let totalPriceAfterDiscount = 0;
        const calc = new articlesCalc();

        props.rows.forEach(row => {
            calc.setData(row);

            var multiplier = Number.parseFloat(props.multiplier);

            if (row.objectsPerRow != undefined && row.objectsPerRow > 0) {
                if (row.infoboard_id == 1 || row.infoboard_id == 3 || (row.infoboard_id == 5 && row.mode == 'waste')) {
                    multiplier = Math.ceil(multiplier / row.objectsPerRow);
                } else if (row.infoboard_id == 2 || (row.infoboard_id == 5 && row.mode == 'size')) {
                    multiplier =
                        Math.ceil(multiplier / row.objectsPerRow) *
                        row.objectsPerRow;
                }
            }

            if (row.is_single) multiplier = 1;

            totalPriceAfterDiscount += Number.parseFloat(
                calc.getPriceAfterDiscount(multiplier)
            );
            row.children.forEach(childRow => {
                calc.setData(childRow);

                multiplier = childRow.is_single
                    ? 1
                    : Number.parseFloat(props.multiplier);

                if (row.objectsPerRow != undefined && row.objectsPerRow > 0 && childRow.auto_calculate_function_name == 'materialAreaM2') {
                    multiplier = Math.ceil(multiplier / row.objectsPerRow);
                }

                totalPriceAfterDiscount += Number.parseFloat(
                    calc.getPriceAfterDiscount(multiplier)
                );
            });
        });

        return totalPriceAfterDiscount.toFixed(2);
    };

    static getTotalUnitPriceAfterDiscount = props => {
        if (props.multiplier == 0) return "0.00";

        let totalPriceAfterDiscount = 0;
        const calc = new articlesCalc();

        props.rows.forEach(row => {
            calc.setData(row);

            var multiplier = Number.parseFloat(props.multiplier);

            if (row.objectsPerRow != undefined && row.objectsPerRow > 0) {
                if (row.infoboard_id == 1 || row.infoboard_id == 3 || (row.infoboard_id == 5 && row.mode == 'waste')) {
                    multiplier = Math.ceil(multiplier / row.objectsPerRow);
                } else if (row.infoboard_id == 2 || (row.infoboard_id == 5 && row.mode == 'size')) {
                    multiplier =
                        Math.ceil(multiplier / row.objectsPerRow) *
                        row.objectsPerRow;
                }
            }

            if (row.is_single) multiplier = 1;

            totalPriceAfterDiscount += Number.parseFloat(
                calc.getPriceAfterDiscount(multiplier)
            );
            row.children.forEach(childRow => {
                calc.setData(childRow);

                multiplier = childRow.is_single
                    ? 1
                    : Number.parseFloat(props.multiplier);

                if (row.objectsPerRow != undefined && row.objectsPerRow > 0 && childRow.auto_calculate_function_name == 'materialAreaM2') {
                    multiplier = Math.ceil(multiplier / row.objectsPerRow);
                }

                totalPriceAfterDiscount += Number.parseFloat(
                    calc.getPriceAfterDiscount(multiplier)
                );
            });
        });

        return (totalPriceAfterDiscount / props.multiplier).toFixed(2);
    };

    static getTotalM2Area = props => {
        let totalArea = 0;

        props.rows.forEach(row => {
            let areaAlreadyFound = false;

            if (row.children.length > 0) {
                row.children.forEach(childRow => {
                    if (childRow.unit == "m2" && !areaAlreadyFound) {

                        if (row.objectsPerRow != undefined && row.objectsPerRow > 0 && childRow.auto_calculate_function_name == 'materialAreaM2') {
                            multiplier = Math.ceil(multiplier / row.objectsPerRow);
                        }

                        totalArea +=
                            Number.parseFloat(childRow.quantity) *
                            Number.parseFloat(props.multiplier);

                        areaAlreadyFound = true;
                    }
                });
            } else {
                if (row.unit == "m2") {
                    let quantity = Number.parseFloat(row.quantity);
                    var multiplier = Number.parseFloat(props.multiplier);

                    if (row.objectsPerRow != undefined && row.objectsPerRow > 0) {
                        multiplier = Math.ceil(multiplier / row.objectsPerRow);
                    }

                    quantity *= multiplier;
                    totalArea += quantity;
                }
            }
        });
        return totalArea.toFixed(2);
    };
}

function getRowAttributes({ article_number }) {
    const route = "/cost-estimates/row-attributes/{article_number}";
    return axios.get(route.replace("{article_number}", article_number));
}

function getRows(costEstimateId) {
    const route = "/cost-estimates/{id}/rows";
    return axios.get(route.replace("{id}", costEstimateId));
}

export default {
    getRowAttributes,
    getRows
};
